import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function EyeStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M15.25 12C15.25 10.205 13.795 8.75 12 8.75C10.205 8.75 8.75002 10.205 8.75002 12C8.75002 13.795 10.205 15.25 12 15.25C13.795 15.25 15.25 13.795 15.25 12ZM16.75 12C16.75 14.6234 14.6234 16.75 12 16.75C9.3766 16.75 7.25002 14.6234 7.25002 12C7.25002 9.37659 9.3766 7.25 12 7.25C14.6234 7.25 16.75 9.37659 16.75 12Z"
				fill="currentColor"
			/>
			<path
				d="M12.0004 4.25C14.3286 4.25013 16.4304 5.36325 18.0971 6.6582C19.7723 7.95977 21.0861 9.50492 21.853 10.5059L21.9721 10.6768C22.4928 11.4869 22.4928 12.5131 21.9721 13.3232L21.853 13.4941C21.0861 14.4951 19.7723 16.0402 18.0971 17.3418C16.4304 18.6367 14.3286 19.7499 12.0004 19.75C9.67212 19.75 7.56961 18.6368 5.90277 17.3418C4.43713 16.203 3.24838 14.8777 2.46039 13.8936L2.14789 13.4941C1.46745 12.6059 1.46748 11.3941 2.14789 10.5059L2.46039 10.1064C3.24838 9.12233 4.43713 7.79697 5.90277 6.6582C7.56961 5.36318 9.67212 4.25 12.0004 4.25ZM12.0004 5.75C10.147 5.75 8.36668 6.64397 6.82367 7.84277C5.48097 8.88597 4.37511 10.1149 3.63324 11.041L3.33832 11.418C3.07021 11.768 3.07022 12.2321 3.33832 12.582L3.63324 12.959C4.37511 13.8851 5.48097 15.114 6.82367 16.1572C8.36668 17.356 10.147 18.25 12.0004 18.25C13.8537 18.2499 15.6333 17.3559 17.1762 16.1572C18.7106 14.9651 19.9352 13.5301 20.6616 12.582L20.7495 12.4453C20.9002 12.1643 20.9002 11.8357 20.7495 11.5547L20.6616 11.418C19.9352 10.4699 18.7106 9.03487 17.1762 7.84277C15.6333 6.6441 13.8537 5.75013 12.0004 5.75Z"
				fill="currentColor"
			/>
		</svg>
	);
}

EyeStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default EyeStrokeIcon;
